module.exports = __webpack_public_path__ + "img/crm_case6.8f47d6f3.png";